import { createContext, useContext } from "react";

export const SiteContext = createContext(null);
export const useSite = () => useContext(SiteContext);

export const lenisRef = { current: null };

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -70, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const EASE = [0.22, 1, 0.36, 1];
